// add to cart donation
$(document).ready(function(e){
    var variantId = 39661250740357; // donation $1 product variant id
    jQuery.getJSON('/cart.js', function(cart) {
      var product = cart.items.find(it => it.variant_id == variantId)
      if (product && product.quantity > 0) {
        $('#add-donation').prop('checked', true)
      }
    });

    $('#add-donation').on('change', function() { 
      if (this.checked) {
        $.ajax({
            method: 'POST',
            url: '/cart/add.js',
            data: {quantity: 1, id: variantId},
            dataType: 'json',
            success: function(){
               location.reload();
            }
        })
      } else {
        $.ajax({
            method: 'POST',
            url: '/cart/change.js',
            data: {quantity: 0, id: variantId},
            dataType: 'json',
            success: function(){
               location.reload();
            }
        })
      }
    });
});


// share url page.share-fundraiser.liquid
// prefills scout group at checkout
$(document).ready(function(e){
  var urlParams = new URLSearchParams(window.location.search);
  var scoutGroup = urlParams.get('scoutGroup');
  if (scoutGroup) {
    $.post('/cart/update.js',{"attributes":{"Group Choice": scoutGroup}},function(cart){},'json');
  }
});